// extracted by mini-css-extract-plugin
module.exports = {"TopContributorsList":"_4fGp3tb","influencer":"_1EbB7hjV"};